import { useCallback, useMemo, useState } from 'react'

import { useCustomEventListener } from 'app/common/ui-next/custom-events'
import { createCustomEvent, dispatchCustomEvent } from 'app/common/ui-next/custom-events'

enum VisibleScrollEvent {
  Visible = 'visible',
}

export const readyToLoad = () => {
  const event = createCustomEvent(VisibleScrollEvent.Visible)
  dispatchCustomEvent(event)
}

interface Options<T> {
  bundleLimit?: number
  data: T
  dataReplacement: (data: T, visiblePortion: number) => T
  skip?: boolean
}

export function useLazyLoading<T>({
  bundleLimit = 20,
  data,
  dataReplacement,
  skip = false,
}: Options<T>) {
  const [visiblePortion, setVisiblePortion] = useState(bundleLimit)

  const visibleData = useMemo(() => {
    if (!data || skip) return null
    return dataReplacement(data, visiblePortion)
  }, [data, visiblePortion, dataReplacement, skip])

  const handleDataBundle = useCallback(() => {
    setVisiblePortion((prevVisiblePortion) => prevVisiblePortion + bundleLimit)
  }, [bundleLimit])

  useCustomEventListener(VisibleScrollEvent.Visible, handleDataBundle)

  return skip ? data : visibleData
}
